export default "__VITE_ASSET__5f3cdd56__"